import {
    ISubscriptionInfo,
    IUserSubscription,
    subscriptionPreferencesAT,
} from "./SubscriptionPreferencesModel";
import { IUmSpAuthState } from "../_features/auth/AuthModel";
import { uuid4 } from "@ngd-web/ngd-persistence-utils/src/_shared/uniqueId";

/*
 */
export const identifyUserOnSubscriptionPreferencesAction = (
    mobile: string
) => ({
    type: subscriptionPreferencesAT.identify,
    mobile,
});

/*
 */
export const reIdentifyUserOnSubscriptionPreferencesAction = {
    type: subscriptionPreferencesAT.reenter,
};

/*
 */
export const reSendCodeUserOnSubscriptionPreferencesAction = {
    type: subscriptionPreferencesAT.reenter,
};

/*
 */
export const submitCodeOnSubscriptionPreferencesAction = {
    type: subscriptionPreferencesAT.submitCode,
};

/*
 */
export const showErrorOnSubscriptionPreferencesAction = (
    error: string,
    fatal = false
) => ({
    type: subscriptionPreferencesAT.error,
    error,
    fatal,
});

/*
 */
export const hasUserOnSubscriptionPreferencesAction = (
    authInfo: IUmSpAuthState
) => ({
    type: subscriptionPreferencesAT.hasUser,
    authInfo,
});

/*
 */
export function hasConsentsOnSubscriptionPreferencesAction(
    consents,
    subscriptions: ISubscriptionInfo[],
    userSubscriptions: IUserSubscription[],
    userId
) {
    const userSubscriptionsObject = userSubscriptions.reduce(
        (sum, next: IUserSubscription) => {
            if (
                subscriptions.some(
                    subscription => subscription.id == next.subscription
                )
            )
                sum[next.id] = next;
            return sum;
        },
        {}
    );

    for (const sType of subscriptions) {
        if (userSubscriptions.some(x => x.subscription === sType.id)) continue;

        const id = "new_" + uuid4();
        userSubscriptionsObject[id] = {
            id,
            userId,
            subscription: sType.id,
        };
    }

    return {
        type: subscriptionPreferencesAT.hasConsents,
        consents,
        subscriptions,
        userSubscriptionsObject,
    };
}

/*
 */
export const toggleGeneralConsentOnSubscriptionPreferencesAction = (
    consentKey: string,
    value: boolean
) => ({
    type: subscriptionPreferencesAT.consentChange,
    consentKey,
    value,
});

/*
 */
export const toggleSubscriptionConsentOnSubscriptionPreferencesAction = (
    consentKey: string,
    consentId: number,
    value: boolean
) => ({
    type: subscriptionPreferencesAT.subscriptionChange,
    consentKey,
    consentId,
    value,
});

/*
 */
export const saveSubscriptionConsentOnSubscriptionPreferencesAction = {
    type: subscriptionPreferencesAT.saveData,
};

/*
 */
export const revertSubscriptionConsentOnSubscriptionPreferencesAction = {
    type: subscriptionPreferencesAT.revertData,
};

/*
 */
export const showInlineErrorsOnSubscriptionPreferencesAction = errors => ({
    errors,
    type: subscriptionPreferencesAT.hasErrorsOnSaveData,
});
